var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.228,
    height: 45.228,
    viewBox: "0 0 45.228 45.228",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_377",
    "data-name": "Group 377",
    transform: "translate(1484.239 -6013.567)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_431",
    "data-name": "Ellipse 431",
    cx: 22.614,
    cy: 22.614,
    r: 22.614,
    transform: "translate(-1484.239 6013.567)",
    fill: "#444e7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19068",
    "data-name": "Path 19068",
    d: "M30.933,118.144A9.607,9.607,0,0,0,16.46,130.708l7.689,10.2,7.689-10.2A9.578,9.578,0,0,0,30.933,118.144Zm-6.784,11.609a4.774,4.774,0,1,1,4.774-4.774A4.772,4.772,0,0,1,24.149,129.753Z",
    transform: "translate(-1485.573 5908.444)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/locationIcon.084faf6b3f7442c25a75a9980a8f3c4f.svg";
export { ForwardRef as ReactComponent };